import { render, staticRenderFns } from "./classroom-filter-sidebar.vue?vue&type=template&id=773f5f46&"
import script from "./classroom-filter-sidebar.vue?vue&type=script&lang=js&"
export * from "./classroom-filter-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports